import React from 'react';
import LegalPage from './LegalPage';
import LegalDocument from '../../legal/LegalDocument';
import { PRIVACY } from '../../legal/documents';

const Privacy: React.FC = () => (
  <LegalPage title="Политика конфиденциальности">
    <LegalDocument nodes={PRIVACY} />
  </LegalPage>
);

export default Privacy;
